export const APP_ENV = (
  process.env.REACT_APP_ENV || "development"
).toLowerCase();

export const API_PATH = "v1";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (APP_ENV === "production"
    ? `https://api.sewoork.com/${API_PATH}`
    : `http://localhost:8080/${API_PATH}`);

export const API_TIMEOUT = 10000;
